import _import from './lazy-importer';
import Home from '@/views/layouts/Home';

export default [
  {
    path: '/',
    name: 'Index',
    redirect: { name: 'ProjectsIndex' }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Home,
    redirect: { name: 'ProjectsIndex' },
    meta: {
      inMenu: true,
      title: '项目列表',
      icon: 'el-icon-location',
      isRenderAsSubmenu: false
    },
    children: [
      {
        path: 'index',
        name: 'ProjectsIndex',
        component: _import('projects/index/Index'),
        meta: { title: '项目列表', notBreadcrumb: true }
      },
      {
        path: 'detail/:projectId',
        name: 'ProjectsDetail',
        component: _import('projects/detail/Index'),
        meta: { title: '项目详情' },
        children: [
          {
            path: 'access',
            name: 'ProjectsDetailAccess',
            component: _import('projects/access/Index'),
            meta: { title: '接入数据' }
          }
        ]
      },
      {
        path: 'access',
        name: 'ProjectsAccess',
        component: _import('projects/access/Index'),
        meta: { title: '接入数据', customBreadcrumb: true }
      }
    ]
  },
  {
    path: '/grok',
    name: 'grokRule',
    component: _import('projects/common/access-rule/GrokRule'),
    meta: { title: 'Grok 提取表达式帮助文档' }
  },
  {
    path: '/configs',
    name: 'Configs',
    component: Home,
    meta: {
      inMenu: true,
      title: '配置管理',
      icon: 'el-icon-setting',
      isRenderAsSubmenu: true,
      notBreadcrumb: true
    },
    children: [
      {
        path: 'contacts',
        name: 'Contacts',
        component: _import('configs/contacts/Index'),
        meta: { title: '联系人管理' }
      }
    ]
  },
  {
    path: '/unavailable',
    name: 'Unavailable',
    component: _import('errors/Unavailable')
  },
  {
    path: '*',
    name: 'Error404',
    component: _import('errors/404')
  }
];
